//@ts-nocheck
import mitt from "mitt";

export function createEventBus() {
    const emitter = mitt();
    return {
        $on: (...args) => emitter.on(...args),
        $off: (...args) => emitter.off(...args),
        $emit: (...args) => emitter.emit(...args),
    };
}
